import _Model from "./_Model";
import Device from "./Device";
import Rule from "./Rule";

export default class ProductCategory extends _Model {
  constructor(json) {
    super(json);
    this.label = ProductCategory.getOrDefault(json, 'label', '');
    this.translationKey = ProductCategory.getOrDefault(json, 'translationKey', '');
    this.description = ProductCategory.getOrDefault(json, 'description', '');
    this.detailedDescription = ProductCategory.getOrDefault(json, 'detailedDescription', '');
    this.imageURL = ProductCategory.getOrDefault(json, 'imageURL', '');
    this.references = ProductCategory.getMappedOrDefault(json, 'references', [], data => (data || []).map(d => new Device(d || {})));
    this.hasPrecommercializedReferences = ProductCategory.getOrDefault(json, 'hasPrecommercializedReferences', false);
    this.failedRulesForReferences = ProductCategory.getMappedOrDefault(json, 'failedRulesForReferences', {}, data => {
      return Object.fromEntries(Object.entries(data || {})
        .map(([k, rulesData]) => [k, (rulesData || []).map(r => new Rule(r || {}))])
      );
    });
    this.maxQuantityForReferences = ProductCategory.getOrDefault(json, 'maxQuantityForReferences', {});
  }

}
